'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import AdPreviewRecord from 'AdsUI/records/ad-management/AdPreviewRecord';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload = {}
  } = action;

  switch (type) {
    case Actions.AD_PREVIEW_FETCH_SUCCEEDED:
      {
        const {
          adId,
          network,
          groupId
        } = payload,
              preview = _objectWithoutPropertiesLoose(payload, ["adId", "network", "groupId"]);

        state = state.setIn([network, groupId, adId], AdPreviewRecord(preview));
        break;
      }

    default:
      break;
  }

  return state;
});